mutation archiveTopic($id: ID!) {
  topic: archiveTopic(id: $id) {
    id
    name
    description
    status
    isSystemGenerated
    isUserEditable
    landingpage {
      id
      slug
    }
  }
}
